import { Link, Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { AppLayout } from "../layouts/AppLayout";
import { DashboardPage } from "../features/dashboard/DashboardPage";
import { NewRequestPage } from "../features/availabilityRequests/NewRequestPage";
import { OpenRequestsPage } from "../features/availabilityRequests/OpenRequestsPage";
import { ResultsPage } from "../features/results/ResultsPage";
import { LogsPage } from "../features/logs/LogsPage";
import { SettingsPage } from "../features/settings/SettingsPage";
import { GlobalSettingsPage } from "../features/settings/GlobalSettingsPage";
import { PlatformHomePage } from "../features/platform/PlatformHomePage";
import { PurchaseInvoicesPage } from "../features/purchaseInvoices/PurchaseInvoicesPage";
import { SalesInvoiceDataPage } from "../features/purchaseInvoices/SalesInvoiceDataPage";
import { OperatorInvoicesPage } from "../features/purchaseInvoices/OperatorInvoicesPage";
import { LoginPage } from "../features/auth/LoginPage";
import { useAuth } from "./AuthContext";
import { hasPermission, type AppPermission } from "../services/authApi";
import { OPERATOR_AUTOMATION_BASE, PURCHASE_INVOICES_BASE } from "./moduleRegistry";

export function App() {
  const { loading } = useAuth();
  if (loading) return null;
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuthenticated />}>
        <Route element={<AppLayout />}>
        <Route index element={<PlatformHomePage />} />
        <Route path="settings" element={<GlobalSettingsPage />} />
        <Route element={<RequirePermission permission="operator_automation" />}>
          <Route path={OPERATOR_AUTOMATION_BASE.slice(1)} element={<DashboardPage />} />
          <Route path={`${OPERATOR_AUTOMATION_BASE.slice(1)}/new`} element={<NewRequestPage />} />
          <Route path={`${OPERATOR_AUTOMATION_BASE.slice(1)}/open`} element={<OpenRequestsPage />} />
          <Route path={`${OPERATOR_AUTOMATION_BASE.slice(1)}/results`} element={<ResultsPage />} />
          <Route path={`${OPERATOR_AUTOMATION_BASE.slice(1)}/logs`} element={<LogsPage />} />
          <Route path={`${OPERATOR_AUTOMATION_BASE.slice(1)}/settings`} element={<SettingsPage />} />
        </Route>
        <Route element={<RequirePermission permission="purchase_invoice_matching" />}>
          <Route path={PURCHASE_INVOICES_BASE.slice(1)} element={<Navigate to={`${PURCHASE_INVOICES_BASE}/canon`} replace />} />
          <Route path={`${PURCHASE_INVOICES_BASE.slice(1)}/applixure/:section?`} element={<SalesInvoiceDataPage key="applixure" vendor="applixure" />} />
          <Route path={`${PURCHASE_INVOICES_BASE.slice(1)}/cuuma/:section?`} element={<SalesInvoiceDataPage key="cuuma" vendor="cuuma" />} />
          <Route path={`${PURCHASE_INVOICES_BASE.slice(1)}/operator-invoices/:section?`} element={<OperatorInvoicesPage />} />
          <Route path={`${PURCHASE_INVOICES_BASE.slice(1)}/:vendor`} element={<PurchaseInvoicesPage />} />
          <Route path={`${PURCHASE_INVOICES_BASE.slice(1)}/:vendor/:section`} element={<PurchaseInvoicesPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}

function RequireAuthenticated() {
  const { user } = useAuth();
  const location = useLocation();
  return user ? <Outlet /> : <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
}

function RequirePermission({ permission }: { permission: AppPermission }) {
  const { user } = useAuth();
  return hasPermission(user, permission) ? <Outlet /> : <AccessDenied />;
}

function AccessDenied() {
  return <section className="card access-denied"><h1>Ei käyttöoikeutta</h1><p>Sinulla ei ole oikeutta tähän moduuliin. Pyydä tarvittaessa käyttöoikeus ylläpitäjältä.</p><Link className="button button--primary" to="/">Palaa etusivulle</Link></section>;
}
